import React from "react";

const Footer = () => {
  return (
    <div className="absolute top-[90%] flex w-full justify-center">
      <div className="m-auto text-sm">
        <p>&copy; 2026</p>
      </div>
    </div>
  );
};

export default Footer;
